"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsernameType = void 0;
/** Type of username used in login */
var UsernameType;
(function (UsernameType) {
    UsernameType["Email"] = "email";
    UsernameType["Mobile"] = "mobile";
    UsernameType["UserName"] = "user_name";
    UsernameType["Sub"] = "sub";
    UsernameType["IdentityId"] = "identityid";
    UsernameType["Custom"] = "custom";
})(UsernameType || (exports.UsernameType = UsernameType = {}));
